/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-edit-rates-and-contract",
  templateUrl: "./edit-rates-and-contract.component.html"
})
export class EditRatesAndContractComponent {
  @Input() updateMode!: boolean;
  @Input() parentGroup!: FormGroup;
  @Input() isInstaMed!: boolean;
  @Input() amexFeeRequired!: boolean;

  decimalDollarAmount(fieldName: string) {
    let val: string = this.parentGroup.get(fieldName)?.value?.toString();
    if (val) {
      const decimalCnt: number = val.split(".", 1) ? val.split(".", 1).length : 0;
      val = decimalCnt && decimalCnt > 2 ? val : parseFloat(val).toFixed(2);
      this.parentGroup.get(fieldName)?.setValue(val);
    }
  }
}
